import { render, staticRenderFns } from "./MenuLogo.vue?vue&type=template&id=163cb70a&scoped=true&lang=pug&"
import script from "./MenuLogo.vue?vue&type=script&lang=js&"
export * from "./MenuLogo.vue?vue&type=script&lang=js&"
import style0 from "./MenuLogo.vue?vue&type=style&index=0&id=163cb70a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163cb70a",
  null
  
)

export default component.exports